module.exports = __webpack_public_path__ + "img/arrow-button-right-2.fefca1f2.svg";